import { ManagerRole } from '../../../../hooks/auth/usePermissions';

export default {
  [ManagerRole.SuperAdmin]: 'Superbeheerder',
  [ManagerRole.Admin]: 'Beheerder',
  [ManagerRole.SalesManager]: 'Verkoopmanager',
  [ManagerRole.SalesLeadership]: 'Salesleiderschap',
  [ManagerRole.ContentManager]: 'Contentbeheerder',
  [ManagerRole.OnboardingManager]: 'Onboardingmanager',
  [ManagerRole.OccAgent]: 'Callcenteragent',
};
